export default __webpack_public_path__ + "assets/restaurant-availability.e0dbecce.svg";